export default () => ({
  index: [],
  cart: [],
});
